export enum AuthErrorCategory {
  NETWORK = 'network',
  VALIDATION = 'validation',
  AUTH = 'auth',
  SYSTEM = 'system'
}

export enum AuthErrorSeverity {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical'
}

export interface AuthErrorDetails {
  code?: string;
  message: string;
  category: AuthErrorCategory;
  severity: AuthErrorSeverity;
  context?: Record<string, any>;
  timestamp: Date;
  userId?: string;
  sessionId?: string;
  userAgent?: string;
  operation: string;
}

export interface AuthNetworkError extends AuthErrorDetails {
  category: AuthErrorCategory.NETWORK;
  statusCode?: number;
  endpoint?: string;
  retryable: boolean;
}

export interface AuthValidationError extends AuthErrorDetails {
  category: AuthErrorCategory.VALIDATION;
  field?: string;
  expectedFormat?: string;
}

export interface AuthenticationError extends AuthErrorDetails {
  category: AuthErrorCategory.AUTH;
  challengeType?: string;
  requiresReauth?: boolean;
}

export interface AuthSystemError extends AuthErrorDetails {
  category: AuthErrorCategory.SYSTEM;
  stackTrace?: string;
  componentName?: string;
}

export type AuthError = AuthNetworkError | AuthValidationError | AuthenticationError | AuthSystemError;